<script>
export default {
  name: "DarkDialogButton",
  props: ["title", "disabled"],
  emits: ["click"],
  setup(props) {
    return {}
  }
}
</script>

<template>
<button class="dark-dialog-button"
        @click.stop="$emit('click')"
        :disabled="disabled"
>
  {{title}}
</button>
</template>

<style scoped lang="scss">
.dark-dialog-button {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 100px;
  padding: 8px 16px 8px 16px;
  border-radius: 8px;
  border: 1px solid #E2E8F0;
  gap: 8px;
  background-color: rgb(51, 65, 85);
  margin: 0;

  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  color: rgb(255, 255, 255);
  cursor: pointer;

  &.save {
    background: #E2E8F0;
  }

  &:disabled {
    color: silver;
    background-color: rgba(51, 65, 85, 0.56);
    cursor: not-allowed;
  }

  &:enabled:active {
    transform: translate(1px, 1px);
  }
}
</style>